import { useEffect, useState } from "react";
import { getDecodedTokenDetails } from "../Token/TokenService";
import { canAccessClientManagement } from "../Auth/AuthValidator";

function SideMenu() {
    const [userInitials, setUserInitials] = useState("");
    const [userRole, setUserRole] = useState("");
    const [atacFlowUser, setAtacFlowUser] = useState<boolean>(false);
    const [deliveryNoteAccess, setDeliveryNoteAccess] = useState(false);
    const [canAccessClientManagment, setClientManagmentAccess] = useState(false);

    useEffect(() => {
        (async () => {
            const tokenDetails = await getDecodedTokenDetails();

            if (tokenDetails?.token) {
                try {
                    const userAtacFlow = tokenDetails.atacFlow;
                    setAtacFlowUser(userAtacFlow);
                    const userRole = tokenDetails.userRole
                    setUserRole(userRole);
                    if (userRole === "AUCHANMBAEMPLOYEE") setDeliveryNoteAccess(true);
                    else setDeliveryNoteAccess(false);
                    await canAccessClientManagement() ? setClientManagmentAccess(true) : setClientManagmentAccess(false);
                } catch (error) {
                    console.error('Failed to decode token', error);
                }
            } else {
                console.error('No token found');
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const tokenDetails = await getDecodedTokenDetails();

            if (tokenDetails?.token) {
                try {
                    const userRole = tokenDetails.userRole
                    const userName = tokenDetails.userName;

                    const firstInitial = userName.split(" ")[0];
                    const secondInitial = userName.split(" ")[1];

                    const initials = firstInitial[0] + secondInitial[0];
                    setUserInitials(initials);
                    setUserRole(userRole);
                } catch (error) {
                    console.error('Failed to decode token', error);
                }
            } else {
                console.error('No token found');
            }
        })();
    }, []);


    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('refreshTokenExpiryTime');
        window.location.reload();
    };

    return (
        <>
            <div className="flex sticky left-0 h-screen top-0 z-10">
                <div
                    className="sticky left-0 h-full top-0 w-16 flex flex-col justify-between border-e bg-white lg:sticky">
                    <div>
                        <div className="inline-flex size-16 items-center justify-center">
                            <span
                                className="grid size-10 place-content-center rounded-lg bg-gray-100 text-xs text-gray-600">
                                {userInitials}
                            </span>
                        </div>

                        <div className="border-t border-gray-100">
                            <div className="px-2">

                                <ul className="space-y-1 border-t border-gray-100 pt-4">
                                    {!deliveryNoteAccess && <li>
                                        <a
                                            href="/my-account/preorders"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="size-5 opacity-75"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                                />
                                            </svg>

                                            <span
                                                className="invisible z-50 absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                Precomenzi
                                            </span>
                                        </a>
                                    </li>}

                                    {!deliveryNoteAccess && !atacFlowUser  && <li>
                                        <a
                                            href="/my-account/orders"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="size-5 opacity-75"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                                                />
                                            </svg>

                                            <span
                                                className="invisible z-50 absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                Comenzi
                                            </span>
                                        </a>
                                    </li>}

                                    {!deliveryNoteAccess && <li>
                                        <a
                                            href="/my-account/invoices"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="size-5 opacity-40"
                                                viewBox="10 10 450 540">
                                                <path
                                                    d="M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                                            </svg>

                                            <span
                                                className="invisible z-50 absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                Facturi
                                            </span>
                                        </a>
                                    </li>}

                                    {!deliveryNoteAccess && <li>
                                        <a
                                            href="/my-account/shipping-csv"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="size-5 opacity-40"
                                                viewBox="0 0 122.88 74.34">
                                                <path
                                                    d="M94.42,18.73l-17.98-0.1V6.53c0-1.8-0.73-3.43-1.92-4.61C73.34,0.73,71.71,0,69.91,0H20.07 c-1.8,0-3.43,0.73-4.61,1.92c-1.18,1.18-1.92,2.81-1.92,4.61c0,0.98,0.79,1.77,1.77,1.77c0.98,0,1.77-0.79,1.77-1.77 c0-0.82,0.34-1.57,0.88-2.11c0.54-0.54,1.29-0.88,2.11-0.88h49.84c0.82,0,1.57,0.34,2.11,0.88c0.54,0.54,0.88,1.29,0.88,2.11v55.41 h-9.98c-0.98,0-1.77,0.79-1.77,1.77c0,0.98,0.79,1.77,1.77,1.77h11.75c0.98,0,1.77-0.79,1.77-1.77v-2.01h10.68 c0.81-18.42,27.26-20.96,29.95,0h5.81l-1.79-19.22l-19.07-7.3L94.42,18.73L94.42,18.73z M2.65,37.54c-1.47,0-2.65-0.8-2.65-1.78 c0-0.98,1.19-1.78,2.65-1.78h23.89c1.47,0,2.65,0.8,2.65,1.78c0,0.98-1.19,1.78-2.65,1.78H2.65L2.65,37.54z M8.12,27.96 c-1.1,0-1.99-0.79-1.99-1.77c0-0.98,0.89-1.77,1.99-1.77h18.43c1.1,0,1.99,0.79,1.99,1.77c0,0.98-0.89,1.77-1.99,1.77H8.12 L8.12,27.96z M10.65,18.38c-1.1,0-1.99-0.79-1.99-1.77c0-0.98,0.89-1.77,1.99-1.77h15.89c1.1,0,1.99,0.79,1.99,1.77 c0,0.98-0.89,1.77-1.99,1.77H10.65L10.65,18.38z M26.46,61.93c0.98,0,1.77,0.79,1.77,1.77c0,0.98-0.79,1.77-1.77,1.77h-6.39 c-1.79,0-3.42-0.78-4.61-2.01c-1.18-1.23-1.92-2.91-1.92-4.69v-13c0-0.98,0.79-1.77,1.77-1.77c0.98,0,1.77,0.79,1.77,1.77v13 c0,0.85,0.35,1.66,0.92,2.25c0.54,0.56,1.27,0.92,2.06,0.92H26.46L26.46,61.93z M44.46,50.37c-6.62,0-11.99,5.37-11.99,11.99 c0,6.62,5.37,11.99,11.99,11.99c6.62,0,11.99-5.37,11.99-11.99C56.44,55.74,51.08,50.37,44.46,50.37L44.46,50.37z M44.46,57.75 c-2.54,0-4.61,2.06-4.61,4.61c0,2.54,2.06,4.61,4.61,4.61c2.54,0,4.61-2.06,4.61-4.61C49.06,59.81,47,57.75,44.46,57.75 L44.46,57.75z M102.06,50.37c-6.62,0-11.99,5.37-11.99,11.99c0,6.62,5.37,11.99,11.99,11.99s11.99-5.37,11.99-11.99 C114.05,55.74,108.68,50.37,102.06,50.37L102.06,50.37z M102.06,57.75c-2.54,0-4.61,2.06-4.61,4.61c0,2.54,2.06,4.61,4.61,4.61 s4.61-2.06,4.61-4.61C106.67,59.81,104.61,57.75,102.06,57.75L102.06,57.75z M89.79,23.81l-8.93-0.1V35.2h14.97L89.79,23.81 L89.79,23.81z" />
                                            </svg>

                                            <span
                                                className="invisible z-50 absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                Livrari CSV
                                            </span>
                                        </a>
                                    </li>}

                                    {!deliveryNoteAccess && canAccessClientManagment && <li>
                                        <a
                                            href="/my-account/return-orders"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >

                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                className="size-5 opacity-75"
                                            >
                                                <g
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.5"
                                                    color="currentColor"
                                                >
                                                    <path d="M17 20a2 2 0 1 0 0-4a2 2 0 0 0 0 4M7 20a2 2 0 1 0 0-4a2 2 0 0 0 0 4"></path>
                                                    <path d="M19 11h3v2c0 2.357 0 3.535-.732 4.268c-.487.487-1.171.65-2.268.704m-14 0c-1.097-.054-1.78-.217-2.268-.704C2 16.535 2 15.357 2 13V9c0-2.357 0-3.536.732-4.268S4.643 4 7 4h3.3c1.117 0 1.675 0 2.127.147a3 3 0 0 1 1.926 1.926c.147.452.147 1.01.147 2.127c0 1.22 0 1.831-.334 2.244q-.099.122-.222.222C13.531 11 12.921 11 11.7 11H8m7 7H9m5.5-12h1.821c1.456 0 2.183 0 2.775.354c.593.353.938.994 1.628 2.276L22 11"></path>
                                                    <path d="M10 13s-.672-.556-1.263-1.084C8.32 11.58 8 11.293 8 11.005c0-.255.25-.492.656-.864C9.232 9.662 10 9 10 9"></path>
                                                </g>
                                            </svg>

                                            <span
                                                className="invisible absolute start-full top-1/2 ms-4 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                Cerere retur
                                            </span>
                                        </a>
                                    </li>}

                                    {(userRole === "ADMIN" || userRole === "SUPERADMIN" || userRole === "B2BSUPPORT") && <li>
                                        <a
                                            href="/my-account/cincu-prices"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                className="size-5 opacity-75"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"/>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 6h.008v.008H6V6Z"/>
                                            </svg>
                                            <span
                                                className="invisible absolute start-full top-1/2 ms-4 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                Actualizare preturi
                                            </span>
                                        </a>
                                    </li>}

                                    {deliveryNoteAccess && <li>
                                        <a
                                            href="/my-account/delivery-note"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                width="1em"
                                                height="1em"
                                                className="size-5 opacity-70"
                                            >
                                                <g
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                >
                                                    <path
                                                        d="M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4M2 6h4m-4 4h4m-4 4h4m-4 4h4"></path>
                                                    <path
                                                        d="M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                                                </g>
                                            </svg>

                                            <span
                                                className="invisible z-50 absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                Aviz de expeditie MBA
                                            </span>
                                        </a>
                                    </li>}

                                    {(userRole === "BASIC") && <li>
                                        <a
                                            href="/my-account/info"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="size-5 opacity-75"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                                />
                                            </svg>

                                            <span
                                                className="invisible absolute start-full top-1/2 ms-4 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                Contul meu
                                            </span>
                                        </a>
                                    </li>}

                                    {canAccessClientManagment && <li>
                                        <a
                                            href="/client-management"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >
                                            <svg
                                                className="size-5 opacity-75"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                height="1em"
                                                width="1em"
                                            >
                                                <path fill="none" d="M0 0h24v24H0z" />
                                                <path
                                                    d="M12 14v2a6 6 0 00-6 6H4a8 8 0 018-8zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm9 6h1v5h-8v-5h1v-1a3 3 0 016 0v1zm-2 0v-1a1 1 0 00-2 0v1h2z" />
                                            </svg>

                                            <span
                                                className="invisible z-50 absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                Client Management
                                            </span>
                                        </a>
                                    </li>}

                                    {canAccessClientManagment && <li>
                                        <a
                                            href="/user-management"
                                            className="group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                                        >
                                            <svg
                                                className="size-5 opacity-75"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                width="1em"
                                                height="1em"
                                            >
                                                <g
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                >
                                                    <path d="M2 21a8 8 0 0 1 10.821-7.487m8.557 3.113a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                                                    <circle cx="10" cy="8" r="5"></circle>
                                                </g>
                                            </svg>

                                            <span
                                                className="invisible z-50 absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                            >
                                                User Management
                                            </span>
                                        </a>
                                    </li>}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="sticky inset-x-0 bottom-0 border-t border-gray-100 bg-white p-2">
                        <form action="#">
                            <button
                                onClick={handleLogout}
                                className="group relative flex w-full justify-center rounded-lg px-2 py-1.5 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="size-5 opacity-75"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                    />
                                </svg>

                                <span
                                    className="invisible z-50 absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white group-hover:visible"
                                >
                                    Logout
                                </span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SideMenu;